<template>
	<v-toolbar-title >
    <b v-if="$route.name == 'home'">
      <v-img src="@/assets/logo.png" alt="Convergeo" width="85%"  style="margin-left: 15px"/>
    </b>
    <b v-else-if="$route.name == 'error'">404 Error</b>
    <b v-else-if="$route.name == 'signin'">SignIn</b>
    <b v-else-if="$route.name == 'signin_alt'">SignIn</b>
    <b v-else-if="$route.name == 'signup'">SignUp</b>
    <b v-else-if="$route.name == 'signup_extra'">SignUp</b>
    <b v-else-if="$route.name == 'docAbout'">AboutUs</b>
    <b v-else-if="$route.name == 'docDisclaimer'">Disclaimer</b>
    <b v-else-if="$route.name == 'docTermsCondition'">Terms & C</b>
    <b v-else-if="$route.name == 'docTermsUse'">Terms of Use</b>
    <b v-else-if="$route.name == 'docRefund'">Refunds</b>
    <b v-else-if="$route.name == 'docCookies'">Cookies Policy</b>
    <b v-else-if="$route.name == 'docPrivacy'">Privacy Policy</b>
    <b v-else-if="$route.name == 'docEULA'">EULA</b>
    <b v-else-if="$route.name == 'products'">Products</b>
    <b v-else-if="$route.name == 'services'">Services</b>
    <b v-else-if="$route.name == 'events'">Events</b>
    <b v-else-if="$route.name == 'clients'">Clients</b>
    <b v-else-if="$route.name == 'subcategories'">Products</b>
    <b v-else-if="$route.name == 'alt_products'">Products</b>
    <b v-else-if="$route.name == 'alt_services'">Services</b>
    <b v-else-if="$route.name == 'alt_events'">Events</b>
    <b v-else-if="$route.name == 'alt_clients'">Clients</b>
    <b v-else-if="$route.name == 'product'">Product Page</b>
    <b v-else-if="$route.name == 'service'">Service Page</b>
    <b v-else-if="$route.name == 'event'">Event Page</b>
    <b v-else-if="$route.name == 'client'">Client Page</b>
    <b v-else-if="$route.name == 'product_alt'">Product Page</b>
    <b v-else-if="$route.name == 'service_alt'">Service Page</b>
    <b v-else-if="$route.name == 'event_alt'">Event Page</b>
    <b v-else-if="$route.name == 'client_alt'">Client Page</b>
    <b v-else-if="$route.name == 'cart'">Your Cart</b>
    <b v-else-if="$route.name == 'bids'">Bids</b>
    <b v-else-if="$route.name == 'wish'">Wishlist</b>
    <b v-else-if="$route.name == 'orders'">Orders</b>
    <b v-else-if="$route.name == 'OrderDetail'">Order Details</b>
    <b v-else-if="$route.name == 'checkout'">Checkout</b>
    <b v-else-if="$route.name == 'reviews'">Reviews</b>
    <b v-else-if="$route.name == 'reserve'">Reserves</b>
    <b v-else-if="$route.name == 'dashboard_home'">Dashboard</b>
    <b v-else-if="$route.name == 'dashboard_profile'">User Profile</b>
    <b v-else-if="$route.name == 'dashboard_qrcode'">Qrcode</b>
    <b v-else-if="$route.name == 'dashboard_notifications'">Notifications</b>
    <b v-else-if="$route.name == 'dashboard_payment'">Payments</b>
    <b v-else-if="$route.name == 'dashboard_transactions'">Transact Log</b>
    <b v-else-if="$route.name == 'dashboard_settings'">Settings</b>
    <b v-else-if="$route.name == 'dashboard_issues'">Report Issues</b>
    <b v-else-if="$route.name == 'dashboard_issues_alt'">Report Issues</b>
    <b v-else>404 Error Page</b> 
  </v-toolbar-title>
</template>

<script>
	export default {
		//
	}
</script>